import {
  Sparkles,
  TrendingUp,
  Eye,
  Play,
  CalendarCheck,
} from "lucide-react";

const signals = [
  { icon: Eye, label: "Bir hizmet galerisi incelendi", score: "+1", highlight: false },
  { icon: Play, label: "Video izlendi", score: "+2", highlight: false },
  { icon: CalendarCheck, label: "Randevu niyeti algılandı", score: "+5", highlight: true },
];

export default function SignalPreview() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute -inset-6 rounded-[2rem] bg-accent-500/10 blur-2xl" />

      <div className="relative rounded-2xl border border-background-700 bg-background-900/60 p-5 md:p-6">
        {/* Header */}
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500/20 text-accent-300">
              <Sparkles className="h-4 w-4" strokeWidth={2.2} />
            </span>
            <div className="leading-tight">
              <p className="text-sm font-semibold text-background-100">Luna Beauty Studio</p>
              <p className="text-xs text-background-400">Canlı görüşme</p>
            </div>
          </div>
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-500/15 px-3 py-1 text-[11px] font-bold text-accent-300">
            <TrendingUp className="h-3 w-3" />
            SMART SIGNAL
          </span>
        </div>

        {/* Mini konuşma */}
        <div className="mt-5 space-y-3">
          <div className="max-w-[85%] rounded-2xl rounded-tl-md bg-background-800/70 px-4 py-3 text-sm leading-relaxed text-background-100">
            Merhaba, lazer epilasyon hakkında bilgi almak istiyorum.
          </div>
          <div className="ml-auto max-w-[85%] rounded-2xl rounded-tr-md bg-accent-500 px-4 py-3 text-sm font-medium leading-relaxed text-primary-950">
            Tabii! Hizmet galerimizi inceleyebilirsiniz.
          </div>
        </div>

        {/* Signal listesi */}
        <div className="mt-5 rounded-xl border border-background-700/70 bg-primary-950/40 p-4">
          {signals.map((signal) => {
            const Icon = signal.icon;
            return (
              <div
                key={signal.label}
                className="flex items-center justify-between gap-3 border-b border-background-800/60 py-2.5 first:pt-1 last:border-b-0 last:pb-1"
              >
                <div className="flex items-center gap-2.5">
                  <span
                    className={
                      signal.highlight
                        ? "flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-accent-500 text-primary-950"
                        : "flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-background-800 text-accent-300"
                    }
                  >
                    <Icon className="h-3.5 w-3.5" strokeWidth={2.2} />
                  </span>
                  <span className="text-sm text-background-200">{signal.label}</span>
                </div>
                <span className="text-sm font-bold text-accent-300">{signal.score}</span>
              </div>
            );
          })}
        </div>

        {/* Potential bar */}
        <div className="mt-5">
          <div className="flex items-center justify-between">
            <p className="text-xs font-semibold text-background-300">Potansiyel</p>
            <p className="text-xs font-bold text-accent-300">Yüksek</p>
          </div>
          <div className="mt-2.5 flex gap-1.5">
            <span className="h-1.5 flex-1 rounded-full bg-background-700" />
            <span className="h-1.5 flex-1 rounded-full bg-background-700" />
            <span className="h-1.5 flex-1 rounded-full bg-accent-500" />
          </div>
          <div className="mt-2 flex justify-between text-[11px] font-medium text-background-400">
            <span>Düşük</span>
            <span>Orta</span>
            <span className="text-accent-300">Yüksek</span>
          </div>
        </div>
      </div>
    </div>
  );
}